import React from 'react'
import { make as Page_ } from 'v5/conversation/conversationsPage/ConversationsPageRelay.bs'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import { withMainLayout as layout } from '../../pagesComponents/MainApp'
import { useRouter } from 'next/router'

const Page = requireAuthenticatedAgent(Page_)

const ConversationsPage = () => {
  const router = useRouter()
  const { slug } = router.query

  return <Page slug={slug} />
}

ConversationsPage.getLayout = layout
export default ConversationsPage
